var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.4222 23.3526C44.3481 23.3401 44.2719 23.3336 44.1941 23.3336C44.1163 23.3336 44.0401 23.3401 43.9661 23.3526H33.0709C28.7414 23.3526 25.0918 26.7157 25.0918 30.8176V48.6726C25.0918 53.0069 28.5811 56.441 33.0709 56.441H46.9769C51.2472 56.441 54.7733 52.8378 54.7733 48.6726V33.396C54.7733 33.0733 54.6429 32.7631 54.4095 32.5303L45.5932 23.737C45.347 23.4914 45.0069 23.3526 44.6514 23.3526H44.4222ZM42.8886 25.8518L33.0709 25.8531C30.1615 25.8531 27.7027 28.1188 27.7027 30.8181V48.6731C27.7027 51.6418 30.0394 53.9415 33.0709 53.9415H46.9769C49.7659 53.9415 52.1623 51.4926 52.1623 48.6731L52.1611 34.9721L50.6372 34.9771C50.0565 34.9764 49.3959 34.9752 48.6613 34.9736C45.5812 34.9674 43.0675 32.6558 42.8978 29.7459L42.8886 29.432V25.8518ZM50.7324 32.4733L48.6671 32.4736C46.9169 32.4701 45.4996 31.1094 45.4996 29.432V27.2543L50.7324 32.4733ZM43.8634 44.6796C44.5844 44.6796 45.1689 45.2392 45.1689 45.9296C45.1689 46.5624 44.6778 47.0854 44.0406 47.1682L43.8634 47.1796H34.4692C33.7482 47.1796 33.1637 46.62 33.1637 45.9296C33.1637 45.2968 33.6548 44.7738 34.292 44.691L34.4692 44.6796H43.8634ZM41.6153 37.676C41.6153 36.9856 41.0309 36.426 40.3099 36.426H34.4683L34.2911 36.4374C33.6539 36.5201 33.1628 37.0431 33.1628 37.676C33.1628 38.3663 33.7473 38.926 34.4683 38.926H40.3099L40.487 38.9145C41.1242 38.8318 41.6153 38.3088 41.6153 37.676Z",
    fill: "#2962FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginIcon2);
export default __webpack_public_path__ + "static/media/Login-Icon2.aeefd1ed2629de325bbe628eaf3b9a1c.svg";
export { ForwardRef as ReactComponent };